'use client';

import { useEffect, useState } from 'react';
import styles from './herobackgroundvideo.module.scss';
import { ImageWrapper } from '@/shared-components/ImageWrapper/ImageWrapper';

export interface HeroBackgroundVideoProps {
    src: string;
    thumbnail?: string;
}

export function HeroBackgroundVideo({ src, thumbnail }: HeroBackgroundVideoProps): React.JSX.Element {
    const [shouldLoadVideo, setShouldLoadVideo] = useState(false);
    const [isVideoReady, setIsVideoReady] = useState(false);

    useEffect(() => {
        // Defer video source to keep the poster as the LCP candidate.
        const timeoutId = setTimeout(() => setShouldLoadVideo(true), 0);
        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <>
            {thumbnail && (
                <ImageWrapper
                    src={thumbnail}
                    loadingStrategy="eager"
                    fetchPriority="high"
                    // Keep poster visible until video can play to avoid a blank/gray flash.
                    className={`${styles.poster} ${isVideoReady ? styles.posterHidden : ''}`}
                    ariaHidden
                    alt=""
                />
            )}
            <video
                aria-hidden
                autoPlay
                loop
                muted
                preload="metadata"
                playsInline
                poster={thumbnail}
                className={`${styles.backgroundVideo} ${isVideoReady ? styles.videoVisible : styles.videoHidden}`}
                onCanPlay={() => setIsVideoReady(true)}
            >
                {shouldLoadVideo && <source src={src} type="video/mp4" />}
            </video>
            <div className={styles.overlay} />
        </>
    );
}
